import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Upload, Select } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { ToastContainer, toast } from "react-toastify";
import IntlMessages from "../../../../util/IntlMessages";
import Editor from "src/components/Editor";
import { useAddProjects } from "src/hooks/services/projects/useAddProjects";
import { useEditProjects } from "src/hooks/services/projects/useEditProjects";
const { TextArea } = Input;
const Add = ({ fields, editSection = false, changeTabEvent }) => {
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("horizontal");
  const { mutate: onAddProjects, isLoading: loadingSave } = useAddProjects();
  const { mutate: onEditProjects, isLoading: loadingEdit } = useEditProjects();
  const [formData, setFormData] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [projectContent, setProjectContent] = useState("");

  useEffect(() => {
    if (fields) {
      const finalData = [];
      for (var key in fields) {
        if (fields.hasOwnProperty(key)) {
          let data = {
            name: [],
            value: "",
          };
          data.name.push(key);
          data.value = fields[key];
          finalData.push(data);
        }
      }
      setFormData(finalData);
      var imageFile = [
        {
          uid: "-1",
          name: "image",
          status: "done",
          url: fields.projectImage,
        },
      ];
      setImageList(imageFile);
      setProjectContent(fields.projectContent);
    }
    return () => {
      form.resetFields();
      setFormData([]);
      setImageList([]);
      setImageFile(null);
      setProjectContent("");
    };
  }, [fields, editSection, form]);

  const saveProjects = (values) => {
    if (!projectContent) {
      return;
    }

    if (imageFile === null && !editSection) {
      return;
    }

    values.projectContent = projectContent;

    const formData = new FormData();
    formData.append("Image", imageFile);
    if (editSection) {
      values.projectId = fields.projectId;
      formData.append("Projects", JSON.stringify(values));
      onEditProjects(formData, {
        onSuccess: (data) => {
          toast.success(<IntlMessages id="notification.successMessage" />);
          form.resetFields();
          changeTabEvent("1");
          setImageList([]);
          setImageFile(null);
          setProjectContent("");
        },
        onError: (err) => {
          toast.error(<IntlMessages id="notification.errorMessage" />);
        },
      });
    } else {
      formData.append("projects", JSON.stringify(values));

      onAddProjects(formData, {
        onSuccess: (data) => {
          toast.success(<IntlMessages id="notification.successMessage" />);
          form.resetFields();
          setImageList([]);
          setImageFile(null);
          setProjectContent("");
        },
        onError: (err) => {
          toast.error(<IntlMessages id="notification.errorMessage" />);
        },
      });
    }
  };

  const formItemLayout =
    formLayout === "horizontal"
      ? {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 14 },
          },
        }
      : null;

  // uploads section

  const beforeUpload = (file) => {
    setImageFile(file);
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      var imageFile = [
        {
          uid: "-2",
          name: "image",
          status: "done",
          url: reader.result,
        },
      ];
      setImageList(imageFile);
    });
    reader.readAsDataURL(file);
    return false;
  };

  const removeUpload = () => {
    setImageList([]);
    setImageFile(null);
  };

  const uploadButton = (
    <div>
      {<PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <>
      <Form
        {...formItemLayout}
        form={form}
        name="saveProjects"
        onFinish={saveProjects}
        fields={formData}
        scrollToFirstError
        autoComplete="off"
      >
        <Form.Item
          name="projectTitle"
          label="عنوان"
          rules={[
            {
              required: true,
              message: "لطفا عنوان را وارد کنید",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="projectLead"
          label="توضیح کوتاه"
          rules={[
            {
              required: true,
              message: "لطفا توضیح کوتاه را وارد کنید",
            },
          ]}
        >
          <TextArea autoSize={{ minRows: 3, maxRows: 5 }} maxLength={150} />
        </Form.Item>

        <Form.Item label="توضیح کامل">
          <Editor
            value={projectContent}
            onChange={(event, editor) => {
              const data = editor.getData();
              setProjectContent(data);
            }}
          />
        </Form.Item>

        <Form.Item label="عکس" required>
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            beforeUpload={beforeUpload}
            onRemove={removeUpload}
            maxCount={1}
            fileList={imageList}
            accept=".png, .jpg, .jpeg"
            showUploadList={{ showPreviewIcon: false }}
          >
            {imageList.length === 1 ? null : uploadButton}
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button
            loading={loadingSave || loadingEdit}
            type="primary"
            htmlType="submit"
          >
            {editSection ? "ویرایش" : "ذخیره"}
          </Button>
        </Form.Item>
      </Form>

      {/* <NotificationContainer /> */}
    </>
  );
};

export default Add;
